"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var getCampusDeviceTypes = function () {
    return (0, service_1.getService)()
        .get('/managed_campus/device_types')
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = getCampusDeviceTypes;
